// Agency suggestions are returned as display strings ending in the 6-digit agency code.
const getAgencyCodeFromSuggestion = (suggestion) => suggestion.slice(-6);

const toPeriodOption = ({ dateValue, dateDisplay }) => ({ value: dateValue, label: dateDisplay.replace('-', ' ') });

const toAgencyOption = ({ agencyCode, agencyName }) => ({ value: agencyCode, label: agencyName });

const getValidationError = ({ period, agencyCode }) => {
  if (!period) return 'Please select a Month/Year';
  if (!agencyCode) return 'Please select an agency name or enter agency code';
  return null;
};

const buildReportRequestBody = ({ period, agencyCode, exportType }) => ({
  Area: 'direct-bill-commission',
  DetailedContext: [
    { name: 'period', value: period },
    { name: 'agencyCode', value: agencyCode },
    { name: 'exportType', value: exportType },
  ],
  TypeOfRedirect: 'Generate-Report',
});

export { buildReportRequestBody, getAgencyCodeFromSuggestion, getValidationError, toAgencyOption, toPeriodOption };
